import Select from './Select.vue';

export default Select;


// WEBPACK FOOTER //
// ./components/Select/index.js